import React from "react";
import "./Integration.css";
import Slider from "react-slick";


class Integration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            rows: 2,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
            ]
        };
        return (
            <div className="integration" name="Partners">
                <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                <div className="container">
                    <h2 className="wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30">Integrations</h2>
                    <div className="integration_main">
                        <Slider {...settings}>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/zapper.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/compound.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/chainlink.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/maker.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/uniswap.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/elementfi.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/polygon.png" />
                                </a>
                            </div>
                            <div className="integration_slide">
                                <a>
                                    <img src="img/partners/wishfinance.png" />
                                </a>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        );
    }
}

export default Integration;
